<template>
  <v-card height="100%" class="px-6">
    <v-card-text class="fill-height d-flex align-center ">
      <v-row dense>
        <v-col cols="12" class="text-h5 font-weight-bold white--text">
          Next steps...
        </v-col>
        <v-col cols="12" class="subtitle-1 lighttext--text">
          {{ subtitle }}
        </v-col>
        <v-col cols="12">
          <v-stepper
            vertical
            v-model="step"
            class="transparent subtitle-1 pb-0"
          >
            <v-stepper-step step="1" :complete="step > 1" color="performance">
              <span class="lighttext--text">
                Choose your plan & activate your
                <span class="text-decoration-underline">14 day free trial</span>
              </span>
            </v-stepper-step>
            <v-stepper-content step="1" v-if="step == 1">
              <v-btn to="/billing" color="white" class="secondary--text">
                Choose your plan
              </v-btn>
            </v-stepper-content>
            <v-stepper-step
              step="2"
              :complete="step > 2"
              :color="step > 1 ? 'performance' : 'secondary'"
            >
              <span class="lighttext--text">
                Schedule & launch culture tracking
              </span>
            </v-stepper-step>
            <v-stepper-content step="2" v-if="step == 2">
              <v-btn
                color="white"
                class="secondary--text"
                @click="showSchedule"
              >
                Schedule Tracking
              </v-btn>
            </v-stepper-content>
            <v-stepper-step
              step="3"
              :color="step > 2 ? 'performance' : 'secondary'"
            >
              <span class="lighttext--text">
                Define {{ t("mission.title", true) }} &
                {{ t("core_values.title", true) }}
              </span>
            </v-stepper-step>
            <v-stepper-content step="3">
              <v-btn color="white" class="secondary--text" to="/company">
                {{ t("mission.title") }} & {{ t("core_values.title_short") }}
              </v-btn>
            </v-stepper-content>
          </v-stepper>
        </v-col>
      </v-row>
    </v-card-text>
    <simple-pulse-settings-dialog
      ref="scheduleDialog"
      v-on:close="getPulseOverview"
    ></simple-pulse-settings-dialog>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import SimplePulseSettingsDialog from "@/components/pulse/SimplePulseSettingsDialog";
export default {
  name: "DashboardSetupCultureTrackingCard",
  components: { SimplePulseSettingsDialog },
  data: () => ({
    loading: false
  }),
  computed: {
    subtitle() {
      if (!this.settings.isPaidPlan) {
        return "While you wait for data to come in, here is what you can do!";
      } else if (!this.pulse_scheduled) {
        return "Your free trial has activated! Let's schedule culture tracking";
      }

      return "You have succesfuly scheduled your culture tracking survey!";
    },
    step() {
      if (this.pulse_scheduled) {
        return 3;
      }
      if (this.settings.isPaidPlan) {
        return 2;
      }

      return 1;
    },
    ...mapGetters({
      users: "user/users",
      settings: "profile/settings",
      profile: "profile/profile",
      pulse_scheduled: "pulse/pulse_scheduled"
    })
  },
  created() {},
  methods: {
    getPulseOverview() {
      Promise.all([this.$store.dispatch("pulse/getOverview")])
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while loading your culture tracking surveys."
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    showSchedule() {
      this.$refs.scheduleDialog.showDialog();
    }
  }
};
</script>

<style lang="scss" scoped>
.v-card {
  background:
    var(--v-secondary-base)
    url("https://res.cloudinary.com/dlw64o4rf/image/upload/v1633018166/web%20images/cc-big-card-background_cxsddx.svg")
    center center / cover no-repeat;
}

::v-deep .v-input__slot fieldset {
  background: rgba(0, 0, 0, 0.38);
}

.v-stepper--vertical ::v-deep .v-stepper__step {
  padding: 12px 24px;
}
</style>
